import { useQuery } from 'react-query';

import { api } from '~/api';

export const useSeedRecommendations = (userUuid) => {
  const { data, ...rest } = useQuery(
    ['seed-recommendations', userUuid],
    () => api.recommendations.fetchSeedRecommendations(),
    {
      enabled: Boolean(userUuid),
    }
  );

  return {
    seedProducts: data?.seedRecommendations,
    ...rest,
  };
};
